import React from "react";
import Sidebar from "../components/sidebar/Sidebar";
import Log from "../components/logs/Log";
import { useLocation, useParams } from "react-router-dom";

// LogPage component renders the logs interface with a sidebar and logs content.
// It receives an openDrawer prop to control the sidebar drawer and extracts route parameters and user data.
const LogPage = ({ openDrawer }) => {
  // useParams hook provides access to route parameters (e.g., processType in this case).
  const params = useParams();

  // useLocation hook provides access to the location object, which contains the state passed through navigation.
  const location = useLocation();

  // UserData object extracts user-specific data from the location state for rendering and authentication purposes.
  const UserData = {
    roles: location.state?.roles, // User roles (e.g., admin, user)
    isAdmin: location.state?.isAdmin, // Boolean flag indicating if the user is an admin
    isAuthenticated: location.state?.isAuthenticated, // Boolean flag indicating if the user is authenticated
    refreshToken: location.state?.refreshToken, // Token used to refresh user session
    accessToken: location.state?.accessToken, // Token used for API requests
    userId: location.state?.userId, // Unique identifier for the user
    username: location.state?.username, // Username of the authenticated user
  };

  return (
    <>
      {/* Sidebar component with openDrawer and userData props. 
          The 'active' prop dynamically sets the active menu item based on the processType parameter. */}
      <Sidebar
        openDrawer={openDrawer}
        userData={UserData}
        active={
         params.processType === "data-all"
            ? 6.1
            : params.processType === "data-ingestion"
            ? 6.2
            : params.processType === "data-transformation"
            ? 6.3
            : 6
        }
      />

      {/* Log component that renders the main content for the logs page. 
          It also receives the openDrawer and userData props. */}
      <Log openDrawer={openDrawer} userData={UserData} />
    </>
  );
};

export default LogPage;
